export { default } from './SidebarMinimizer'


// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMinimizer/index.js